import { Link } from "react-router-dom";
import type { MemberSummary } from "../../api/members";
import { AvatarBadge } from "../AvatarBadge";
import { ElectedRoleBadges } from "./ElectedRoleBadges";

interface MemberTableProps {
  members: MemberSummary[];
}

function categoryLabel(category: MemberSummary["membership_category"]): string {
  return category === "efetivo" ? "Efetivo" : "Colaborador";
}

function statusLabel(status: MemberSummary["status"]): string {
  if (status === "suspenso_disciplinar") return "Suspenso disciplinar";
  if (status === "desligado") return "Desligado";
  return "Ativo";
}

function formatDate(value: string | null): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat("pt-BR", { dateStyle: "medium" }).format(new Date(`${value}T12:00:00`));
}

export function MemberTable({ members }: MemberTableProps) {
  return (
    <div className="members-table-wrap">
      <table className="members-table">
        <caption className="visually-hidden">Lista de associados encontrados</caption>
        <thead>
          <tr>
            <th scope="col">Associado</th>
            <th scope="col" className="members-table__username">Usuário</th>
            <th scope="col">Categoria</th>
            <th scope="col">Situação</th>
            <th scope="col" className="members-table__effective">Efetivo desde</th>
            <th scope="col"><span className="visually-hidden">Ação</span></th>
          </tr>
        </thead>
        <tbody>
          {members.map((member) => {
            const displayName = member.preferred_name ?? member.full_name;
            return (
              <tr key={member.id}>
                <th scope="row">
                  <div className="members-table__identity">
                    <AvatarBadge name={displayName} username={member.username ?? displayName} size="sm" />
                    <div className="members-table__identity-text">
                      <strong>{displayName}</strong>
                      {member.preferred_name && <span>{member.full_name}</span>}
                      <ElectedRoleBadges roles={member.elected_roles} />
                    </div>
                  </div>
                </th>
                <td className="members-table__username" data-label="Usuário">{member.username ?? "Sem usuário ativo"}</td>
                <td data-label="Categoria">{categoryLabel(member.membership_category)}</td>
                <td data-label="Situação">
                  <span className={`member-status member-status--${member.status}`}>{statusLabel(member.status)}</span>
                </td>
                <td className="members-table__effective" data-label="Efetivo desde">{formatDate(member.effective_since)}</td>
                <td className="members-table__action" data-label="">
                  <Link to={`/associados/${member.id}`} aria-label={`Abrir ficha de ${member.full_name}`}>
                    Abrir ficha
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
